import { useQuery } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse/types'
import { getTopWorkers, TopWorkers } from 'api/pulse/topWorkers'
import { getTopWorkersKey } from 'queries/pulse/keys'
import { PULSE_QUERY_OPTIONS } from './constants'

export function useTopWorkers(query: PulseFilters) {
  return useQuery<TopWorkers>({
    ...PULSE_QUERY_OPTIONS,
    queryKey: getTopWorkersKey(query),
    queryFn: ({ signal }) => getTopWorkers(query, signal),
    enabled: !!query.companyIds?.length,
  })
}
